import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-9f6f1f5e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_createTextVNode("班");
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    return function (_ctx, _cache) {
      var _component_a_input_number = _resolveComponent("a-input-number");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_input_group = _resolveComponent("a-input-group");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfClassName.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "在考班级：",
            name: "className"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input_group, {
                compact: "",
                class: "radius-number-appear"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_input_number, {
                    allowClear: "",
                    size: "large",
                    value: _unref(formState).className,
                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(formState).className = $event;
                    }),
                    placeholder: "在考班级",
                    style: {
                      "width": "180px"
                    },
                    min: 1,
                    max: 10000,
                    precision: 0
                  }, null, 8, ["value"]), _createVNode(_component_a_button, {
                    size: "large"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_1];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});